import { c as _c } from "react/compiler-runtime";
import { Menu, Switch, TextInput, Tooltip } from '@mantine/core';
import { openConfirmModal } from '@mantine/modals';
import { RichText } from 'components/form/RichText';
import { OverflowMenu } from 'components/Menu';
import { HiTrash } from 'react-icons/hi';
import { Workspace as W } from '../workspace';
import { StyleProps } from 'shared/ui/uiType';
import { keys } from 'shared/collection';
import { LabelForm } from 'shared/ui';
import { SaveStatusCircle } from 'components/form/SaveStatusCircle';
import { Owner } from 'components/question/QuestionOwner';
import { InfoTip } from 'components/Info';
import { ChildrenProps } from 'components';
import { AdminSection } from './AdminComponents';
import { WorkspaceTypes } from 'shared/forecast/workspaceTypes';
import { ComponentProps } from 'react';
import { match } from 'ts-pattern';
import { AdminSubscription } from './AdminSubscription';
import { env } from 'utils/env';
import { usePortal } from '../portal';
import type { GetInputProps, LooseKeys } from 'components/hooks/useDbForm';
export const AdminWorkspace = t0 => {
  const $ = _c(17);
  const {
    className,
    uWorkspace: t1
  } = t0;
  const {
    id,
    form: f,
    del,
    row
  } = t1;
  if (!id || !f.values || !row) {
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <></>;
      $[0] = t2;
    } else {
      t2 = $[0];
    }
    return t2;
  }
  const v = f.values;
  const t2 = `flex gap-12 max-w-[60em] items-start ${className ?? ""}`;
  let t3;
  if ($[1] !== f || $[2] !== row.created_by) {
    t3 = <WorkspaceForm form={f} created_by={row.created_by} className="grow" />;
    $[1] = f;
    $[2] = row.created_by;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== f.isDirty) {
    t4 = <SaveStatusCircle className="" isDirty={f.isDirty} />;
    $[4] = f.isDirty;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <HiTrash />;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== del || $[8] !== v.name) {
    t6 = <OverflowMenu width={200}><Menu.Item leftSection={t5} onClick={() => {
        openConfirmModal({
          title: <span>Delete workspace: <b>{v.name}</b>?</span>,
          centered: true,
          children: <p>Are you sure you want to delete the workspace for all users? The questions contained will no longer be available for forecasting or review.</p>,
          labels: {
            confirm: "Delete Workspace",
            cancel: "Cancel"
          },
          confirmProps: {
            color: "red",
            variant: "filled"
          },
          onConfirm: async () => {
            await del();
          }
        });
      }}>Delete Workspace</Menu.Item></OverflowMenu>;
    $[7] = del;
    $[8] = v.name;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t4 || $[11] !== t6) {
    t7 = <div className="mt-6 flex items-center gap-6">{t4}{t6}</div>;
    $[10] = t4;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t2 || $[14] !== t3 || $[15] !== t7) {
    t8 = <div className="flex flex-col gap-8 p-2"><div className={t2}>{t3}{t7}</div></div>;
    $[13] = t2;
    $[14] = t3;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
};
export const WorkspaceForm = t0 => {
  const $ = _c(44);
  const {
    form,
    created_by,
    className,
    hideOwner,
    children,
    onSubmit
  } = t0;
  const {
    getInputProps: inProps
  } = form;
  let t1;
  if ($[0] !== inProps) {
    t1 = key => inProps(key, {
      type: "checkbox"
    });
    $[0] = inProps;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const inPropsCheck = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      hideExpand: true,
      classNames: {
        container: "flex flex-col gap-4 pt-2",
        root: "min-w-[15em]"
      }
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const defaultAdminSectionProps = t2;
  const {
    profiles
  } = usePortal();
  let t3;
  if ($[3] !== profiles.global) {
    t3 = profiles.global?.hasRole("admin");
    $[3] = profiles.global;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const isGlobalAdmin = t3;
  const t4 = `flex flex-col gap-4 items-start ${className ?? ""}`;
  const t5 = onSubmit ?? _temp;
  let t6;
  if ($[5] !== inProps) {
    t6 = inProps("name");
    $[5] = inProps;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t6) {
    t7 = <TextInput className="sensitive" variant="title" placeholder="Workspace name" data-autofocus={true} {...t6} />;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== inProps) {
    t8 = inProps("description");
    $[9] = inProps;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t8) {
    t9 = <RichText className="sensitive" placeholder="workspace description" {...t8} />;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== created_by || $[14] !== hideOwner || $[15] !== inProps || $[16] !== inPropsCheck || $[17] !== isGlobalAdmin) {
    t10 = isGlobalAdmin && <AdminSection title="Manage" {...defaultAdminSectionProps}><Switch label="Archived" {...inPropsCheck("archived")} />{!hideOwner && <div className="flex justify-start"><Owner label={<div className="flex gap-2 items-center"><LabelForm>Owner</LabelForm><InfoTip label="This person is responsible for this workspace, and will receive notifications as appropriate to administer the workspace " /></div>} showName={true} created_by={created_by} {...inProps("owner")} /></div>}</AdminSection>;
    $[13] = created_by;
    $[14] = hideOwner;
    $[15] = inProps;
    $[16] = inPropsCheck;
    $[17] = isGlobalAdmin;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== inPropsCheck) {
    t11 = inPropsCheck("hideIdentities");
    $[19] = inPropsCheck;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t11) {
    t12 = <Switch label="Hide identities" {...t11} />;
    $[21] = t11;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== inPropsCheck) {
    t13 = inPropsCheck("logActivity");
    $[23] = inPropsCheck;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== t13) {
    t14 = <Tooltip label="When enabled, detailed information about what the user sees inside the app can be seen by Swift tech support"><div><Switch label="Log activity" {...t13} /></div></Tooltip>;
    $[25] = t13;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== t12 || $[28] !== t14) {
    t15 = <AdminSection title="Privacy & Security" {...defaultAdminSectionProps}>{t12}{t14}</AdminSection>;
    $[27] = t12;
    $[28] = t14;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== inPropsCheck || $[31] !== isGlobalAdmin) {
    t16 = isGlobalAdmin && <AdminSection title="Features" {...defaultAdminSectionProps}>{!env.NEXT_PUBLIC_SELF_HOST && <Tooltip label="Show UI features primarily used internal swift usage (e.g. participation, due dates, draft filters)"><div><Switch label="Advanced UI" {...inPropsCheck("advancedUI")} /></div></Tooltip>}<Switch label="Enable feedback" {...inPropsCheck("enableFeedback")} />{!env.NEXT_PUBLIC_SELF_HOST && keys(WorkspaceTypes.defaultFeatures).map(f => <Switch key={f} label={match(f).with("comparison-search", _temp2).exhaustive()} {...inPropsCheck(`features.${f}`)} />)}</AdminSection>;
    $[30] = inPropsCheck;
    $[31] = isGlobalAdmin;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== t10 || $[34] !== t15 || $[35] !== t16) {
    t17 = <div className="flex flex-wrap gap-6 mt-8">{t10}{t15}{t16}</div>;
    $[33] = t10;
    $[34] = t15;
    $[35] = t16;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== children || $[38] !== t17 || $[39] !== t4 || $[40] !== t5 || $[41] !== t7 || $[42] !== t9) {
    t18 = <form className={t4} onSubmit={t5}>{t7}{t9}{t17}{children}</form>;
    $[37] = children;
    $[38] = t17;
    $[39] = t4;
    $[40] = t5;
    $[41] = t7;
    $[42] = t9;
    $[43] = t18;
  } else {
    t18 = $[43];
  }
  return t18;
};
function _temp(e) {
  e.preventDefault();
}
function _temp2() {
  return "Comparison Search";
}